// extracted by mini-css-extract-plugin
export default {"input":"DiscussionDateAndTime_input__X94uO"};